module.exports = __webpack_public_path__ + "img/planting_01@2x.d602784.jpg";